import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, useMemo, useState, } from 'react';
import classnames from 'classnames';
import { AccordionContext } from './AccordionContext';
import { AccordionItem } from './AccordionItem';
const Accordion = ({ activeItemsIds = [], autoClose = true, children, className, onSelect, ...rest }) => {
    // add id for the accordion items
    const arrayChildren = Children.toArray(children).map((child, index) => {
        return cloneElement(child, {
            id: child.props?.id || `accordion-${index}`,
        });
    });
    const [activeItemId, setActiveItemId] = useState(activeItemsIds);
    const contextValue = useMemo(() => ({
        activeItemId,
        onSelect,
        autoClose,
        setActiveItemId,
    }), [activeItemId, autoClose, onSelect]);
    return (_jsx(AccordionContext.Provider, { value: contextValue, children: _jsx("div", { className: classnames(className, 'p-0 m-0 border-0 w-100 align-baseline'), ...rest, children: arrayChildren }) }));
};
Accordion.Item = AccordionItem;
export { Accordion };
